<div class="container-fluid">

    <div class="pageheader d-flex align-items-center justify-content-between mb-2">
        <h4 class="d-flex align-items-center mb-1">
               Case Search
         </h4>
    </div>

    <app-card title="Search Criteria">
      <form [formGroup]="searchCriteria" autocomplete="off" class="small">

        <div class="row mb-3">
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Case Status</label>
            <select class="form-select form-select-sm" formControlName="caseStatusType">
              <option [value]=""></option>
              <option *ngFor="let status of caseStatuses" [value]="status.id">{{status.name}}</option>
            </select>
          </div>
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Case Reference</label>
            <input class="form-control form-control-sm"  maxlength="250" formControlName="caseReference">
          </div>
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Company Group</label>
            <select class="form-select form-select-sm" formControlName="companyGroupId">
              <option [value]=""></option>
              <option *ngFor="let group of companyGroups" [value]="group.id">{{group.name}}</option>
            </select>
          </div>
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Case Type</label>
            <select class="form-select form-select-sm" formControlName="typeId">
              <option [value]=""></option>
              <option *ngFor="let type of caseTypes" [value]="type.id">{{type.caseTypeName}}</option>
            </select>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Paralegal</label>
            <select class="form-select form-select-sm" formControlName="allocatedToParalegalUserId">
              <option [value]=""></option>
              <option *ngFor="let user of paralegalUsers" [value]="user.id">{{user.fullName}}</option>
            </select>
          </div>
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Admin</label>
            <select class="form-select form-select-sm" formControlName="allocatedToAdminUserId">
              <option [value]=""></option>
              <option *ngFor="let user of adminUsers" [value]="user.id">{{user.fullName}}</option>
            </select>
          </div>
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Instructed From</label>
            <input type="date" class="form-control form-select-sm" formControlName="instructedDateFrom">
          </div>
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Instructed To</label>
            <input type="date" class="form-control form-select-sm" formControlName="instructedDateTo">
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Party One Last Name</label>
            <input class="form-control form-control-sm"  maxlength="100" formControlName="partyOneLastName">
          </div>
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Party One Address Line 1</label>
            <input class="form-control form-control-sm" maxlength="100" formControlName="partyOneAddressLine1">
          </div>
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Party One Postcode</label>
            <input class="form-control form-control-sm" maxlength="10" formControlName="partyOnePostcode">
          </div>
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Property Address Line 1</label>
            <input class="form-control form-control-sm" maxlength="100" formControlName="propertyAddressLine1">
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Property Postcode</label>
            <input class="form-control form-control-sm" maxlength="10" formControlName="propertyPostcode">
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-secondary" (click)="doClear()">Clear</button>
          <button type="button" class="btn btn-success" (click)="doSearch()">Search</button>
        </div>

      </form>
    </app-card>

      <app-card [title]="resultsTitle">
        <div>

      <table mat-table [dataSource]="results" matSort matSortActive="caseReference" matSortDisableClear matSortDirection="desc" width="100%" class="small">

        <ng-container matColumnDef="caseReference">
          <mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Case Ref.</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let case"> {{case.caseReference}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="caseStatus">
          <mat-header-cell *matHeaderCellDef>
              <span>Status.</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let case"> {{case.caseStatusTypeText}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="paralegal">
            <mat-header-cell *matHeaderCellDef>
                <span>Paralegal.</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let case">
                <span>
                    {{case.paralegalUserFirstName}} {{case.paralegalUserLastName}}
                </span>
              </mat-cell>
            </ng-container>

        <ng-container matColumnDef="companyGroup">
          <mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Company.</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let case"> {{case.companyGroupName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="instructedDate">
          <mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Instructed Date.</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let case"> {{case.instructedDate  | date:'dd/MM/yyyy'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="caseType">
          <mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Type.</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let case"> {{case.caseTypeName}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="partyOneFirstName">
            <mat-header-cell *matHeaderCellDef>
                <span mat-sort-header>First Name.</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let case"> {{case.partyOneFirstName}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="partyOneLastName">
            <mat-header-cell *matHeaderCellDef>
                <span mat-sort-header>Last Name.</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let case"> {{case.partyOneLastName}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="partyOneAddressLine1">
            <mat-header-cell *matHeaderCellDef>
                <span mat-sort-header>Party 1 Add Line 1.</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let case"> {{case.partyOneAddressLine1}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="partyOnePostCode">
            <mat-header-cell *matHeaderCellDef>
                <span mat-sort-header>Party 1 Postcode.</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let case"> {{case.partyOnePostcode}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="propertyPostcode">
              <mat-header-cell *matHeaderCellDef>
                  <span mat-sort-header>Prop Postcode.</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let case"> {{case.postcode}} </mat-cell>
            </ng-container>

          <ng-container matColumnDef="propertyAddressLine1">
              <mat-header-cell *matHeaderCellDef>
                  <span mat-sort-header>Prop Add Line 1.</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let case"> {{case.propertyAddressLine1}} </mat-cell>
            </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
        <mat-row *matRowDef="let case; columns: displayedColumns;" [routerLink]="['/case', case.id]" class="clickable-list-item"></mat-row>

      </table>

      <div class="spinner-container" *ngIf="isLoadingResults">
        <mat-spinner color="primary" diameter="20"></mat-spinner>
    </div>
      <mat-paginator [length]="resultsLength" [pageSize]="10" [pageSizeOptions]="[10, 25, 50]" [showFirstLastButtons]="true">
      </mat-paginator>

      </div>
      </app-card>

</div>
